/* globals $ */
export default function toggleParallax () {
  if ($(window).innerWidth() < 642) {
    $('.parallax div.image').css('display', 'block');
    $('.parallax ul').css('display', 'none');
  } else {
    $('.parallax div.image').css('display', 'none');
    $('.parallax ul').css('display', 'block');
  }
}


// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/toggleParallax.js